import React, { useEffect, useState } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import useAuth from '../../../../hooks/useAuth'
import IssueApi from '../../../../api/IssueApi'
import { IssueForm } from './IssueForm'
import { IssueEntity } from 'types/IssueEntity'

const issueApi = new IssueApi()

export function EditIssueForm({
    issueId,
    onChangeIssue,
}: {
    issueId?: string
    onChangeIssue: (issue: IssueEntity) => void
}) {
    const { isAuthenticated } = useAuth()
    const [issue, setIssue] = useState<IssueEntity | null>(null)

    const fetchData = React.useCallback(async () => {
        if (!isAuthenticated || !issueId) return
        const result = await issueApi.findByIssueId(issueId, false)

        if (result) {
            setIssue(result)
            onChangeIssue(result)
        }
    }, [isAuthenticated, issueId, onChangeIssue])

    useEffect(() => {
        void fetchData()
    }, [issueId, isAuthenticated, onChangeIssue, fetchData])

    if (!issue) return <LinearProgress />
    return <IssueForm issue={issue} reFetchData={fetchData} />
}
